import { useState, useEffect, useRef } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API || "https://www.vilaro.ro/api";

const card = {
  background: "rgba(255,255,255,0.03)",
  border: "1px solid rgba(255,255,255,0.08)",
};

const btnPrimary = {
  background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
  color: "white",
};

const btnGray = {
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(255,255,255,0.08)",
  color: "rgba(255,255,255,0.7)",
};

const btnGreen = {
  background: "rgba(34,197,94,0.15)",
  border: "1px solid rgba(34,197,94,0.3)",
  color: "#86efac",
};

const btnRed = {
  background: "rgba(239,68,68,0.1)",
  border: "1px solid rgba(239,68,68,0.2)",
  color: "#fca5a5",
};

const btnYellow = {
  background: "rgba(234,179,8,0.15)",
  border: "1px solid rgba(234,179,8,0.3)",
  color: "#fde047",
};

const btnPurple = {
  background: "rgba(139,92,246,0.15)",
  border: "1px solid rgba(139,92,246,0.3)",
  color: "#c4b5fd",
};

const inputStyle = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.1)",
  color: "white",
  outline: "none",
};

const statusColors = {
  draft: { background: "rgba(255,255,255,0.06)", color: "rgba(255,255,255,0.4)" },
  active: { background: "rgba(34,197,94,0.15)", color: "#86efac" },
  completed: { background: "rgba(99,102,241,0.15)", color: "#a5b4fc" },
};

const postStatusColors = {
  empty: { background: "rgba(255,255,255,0.06)", color: "rgba(255,255,255,0.4)" },
  generated: { background: "rgba(234,179,8,0.15)", color: "#fde047" },
  approved: { background: "rgba(99,102,241,0.15)", color: "#a5b4fc" },
  posted: { background: "rgba(34,197,94,0.15)", color: "#86efac" },
  pending: { background: "rgba(255,255,255,0.06)", color: "rgba(255,255,255,0.4)" },
  scheduled: { background: "rgba(234,179,8,0.15)", color: "#fde047" },
};

// Conversie text -> bold Unicode
const toItalicUnicode = (text) => {
  const italic = {
    'a':'𝘢','b':'𝘣','c':'𝘤','d':'𝘥','e':'𝘦','f':'𝘧','g':'𝘨','h':'𝘩','i':'𝘪','j':'𝘫',
    'k':'𝘬','l':'𝘭','m':'𝘮','n':'𝘯','o':'𝘰','p':'𝘱','q':'𝘲','r':'𝘳','s':'𝘴','t':'𝘵',
    'u':'𝘶','v':'𝘷','w':'𝘸','x':'𝘹','y':'𝘺','z':'𝘻',
    'A':'𝘈','B':'𝘉','C':'𝘊','D':'𝘋','E':'𝘌','F':'𝘍','G':'𝘎','H':'𝘏','I':'𝘐','J':'𝘑',
    'K':'𝘒','L':'𝘓','M':'𝘔','N':'𝘕','O':'𝘖','P':'𝘗','Q':'𝘘','R':'𝘙','S':'𝘚','T':'𝘛',
    'U':'𝘜','V':'𝘝','W':'𝘞','X':'𝘟','Y':'𝘠','Z':'𝘡'
  };
  return text.split('').map(c => italic[c] || c).join('');
};

const toBoldUnicode = (text) => {
  const bold = {
    'a':'𝗮','b':'𝗯','c':'𝗰','d':'𝗱','e':'𝗲','f':'𝗳','g':'𝗴','h':'𝗵','i':'𝗶','j':'𝗷',
    'k':'𝗸','l':'𝗹','m':'𝗺','n':'𝗻','o':'𝗼','p':'𝗽','q':'𝗾','r':'𝗿','s':'𝘀','t':'𝘁',
    'u':'𝘂','v':'𝘃','w':'𝘄','x':'𝘅','y':'𝘆','z':'𝘇',
    'A':'𝗔','B':'𝗕','C':'𝗖','D':'𝗗','E':'𝗘','F':'𝗙','G':'𝗚','H':'𝗛','I':'𝗜','J':'𝗝',
    'K':'𝗞','L':'𝗟','M':'𝗠','N':'𝗡','O':'𝗢','P':'𝗣','Q':'𝗤','R':'𝗥','S':'𝗦','T':'𝗧',
    'U':'𝗨','V':'𝗩','W':'𝗪','X':'𝗫','Y':'𝗬','Z':'𝗭',
    '0':'𝟬','1':'𝟭','2':'𝟮','3':'𝟯','4':'𝟰','5':'𝟱','6':'𝟲','7':'𝟳','8':'𝟴','9':'𝟵'
  };
  return text.split('').map(c => bold[c] || c).join('');
};

const TextEditor = ({ value, onChange, rows = 8, style: customStyle }) => {
  const ref = useRef(null);
  
  const applyFormat = (converter) => {
    const el = ref.current;
    if (!el) return;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    if (start === end) return;
    const selected = value.substring(start, end);
    const converted = converter(selected);
    const newText = value.substring(0, start) + converted + value.substring(end);
    onChange(newText);
    setTimeout(() => {
      el.selectionStart = start;
      el.selectionEnd = start + converted.length;
      el.focus();
    }, 0);
  };

  return (
    <div>
      <div className="flex gap-1 mb-1">
        <button type="button" onClick={() => applyFormat(toBoldUnicode)}
          className="px-2 py-0.5 rounded text-xs font-bold"
          style={{background:"rgba(255,255,255,0.08)",color:"white",border:"1px solid rgba(255,255,255,0.15)"}}>
          B
        </button>
        <button type="button" onClick={() => applyFormat(toItalicUnicode)}
          className="px-2 py-0.5 rounded text-xs italic"
          style={{background:"rgba(255,255,255,0.08)",color:"white",border:"1px solid rgba(255,255,255,0.15)"}}>
          I
        </button>
        <span className="text-xs self-center" style={{color:"rgba(255,255,255,0.25)"}}>Selecteaza si apasa B sau I</span>
      </div>
      <textarea ref={ref}
        className="w-full rounded-xl px-3 py-2.5 text-sm resize-none"
        style={{...inputStyle, ...customStyle}}
        rows={rows}
        value={value}
        onChange={e => onChange(e.target.value)} />
    </div>
  );
};

const PageGroup = ({ title, icon, color, pages, selectedIds, onToggle, delay, onDelayChange, showDelay }) => {
  if (pages.length === 0) return (
    <div className="rounded-xl p-4" style={{background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.06)"}}>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium" style={{color}}>{icon} {title}</span>
        <span className="text-xs" style={{color:"rgba(255,255,255,0.25)"}}>Nicio pagină configurată</span>
      </div>
    </div>
  );
  return (
    <div className="rounded-xl p-4" style={{background:"rgba(255,255,255,0.02)", border:`1px solid ${color}40`}}>
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-semibold" style={{color}}>{icon} {title}</span>
        {showDelay && (
          <div className="flex items-center gap-2">
            <span className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>T+</span>
            <input type="number" min="1" max="1440"
              className="w-16 rounded-lg px-2 py-1 text-xs text-center" style={inputStyle}
              value={delay}
              onChange={e => onDelayChange(parseInt(e.target.value) || 0)} />
            <span className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>min</span>
          </div>
        )}
      </div>
      <div className="grid grid-cols-2 gap-2">
        {pages.map(p => (
          <label key={p.id}
            className="flex items-center gap-2 p-2.5 rounded-xl cursor-pointer transition-all"
            style={selectedIds.includes(p.id)
              ? {background:`${color}20`, border:`1px solid ${color}50`}
              : {background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)"}}>
            <input type="checkbox" checked={selectedIds.includes(p.id)}
              onChange={() => onToggle(p.id)}
              className="accent-indigo-500" />
            <span className="text-sm" style={{color:"rgba(255,255,255,0.8)"}}>{p.name}</span>
          </label>
        ))}
      </div>
      )}
    </div>
  );
};

const FormFields = ({ data, setData, pages, domains }) => {
  const officialPages = pages.filter(p => p.page_type === "official");
  const supportPages = pages.filter(p => p.page_type === "support");
  const thematicPages = pages.filter(p => p.page_type === "thematic");
  const reactionPages = pages.filter(p => p.page_type === "reaction");

  const togglePage = (pageId) => setData(prev => ({
    ...prev,
    page_ids: prev.page_ids.includes(pageId)
      ? prev.page_ids.filter(id => id !== pageId)
      : [...prev.page_ids, pageId]
  }));

  return (
    <div className="grid gap-4">
      <div>
        <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.5)"}}>Domeniu</label>
        <select className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
          value={data.domain_id}
          onChange={e => setData(prev => ({...prev, domain_id: e.target.value}))}>
          <option style={{color:"black"}} value="">Fara domeniu</option>
          {domains.map(d => <option style={{color:"black"}} key={d.id} value={String(d.id)}>{d.name}</option>)}
        </select>
      </div>
      <input className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
        placeholder="Titlu / Tema" value={data.title}
        onChange={e => setData(prev => ({...prev, title: e.target.value}))} />
      <textarea className="w-full rounded-xl px-3 py-2.5 text-sm resize-none" style={inputStyle}
        placeholder="Context" rows={2} value={data.context}
        onChange={e => setData(prev => ({...prev, context: e.target.value}))} />
      <textarea className="w-full rounded-xl px-3 py-2.5 text-sm resize-none" style={inputStyle}
        placeholder="Puncte cheie (separate prin virgula)" rows={2} value={data.key_points}
        onChange={e => setData(prev => ({...prev, key_points: e.target.value}))} />

      <div className="rounded-xl p-4" style={{background:"rgba(99,102,241,0.05)", border:"1px solid rgba(99,102,241,0.3)"}}>
        <div className="flex items-center mb-3">
          <span className="text-sm font-semibold" style={{color:"#a5b4fc"}}>📢 OFFICIAL — T0</span>
        </div>
        {data.locked ? (
          <div className="w-full rounded-xl px-3 py-2 text-sm" style={{...inputStyle, opacity:0.5}}>
            {pages.find(p => p.id === data.main_page_id)?.name || "Nicio pagina"} (nu poate fi schimbata)
          </div>
        ) : (
          <select className="w-full rounded-xl px-3 py-2 text-sm" style={inputStyle}
            value={data.main_page_id}
            onChange={e => setData(prev => ({...prev, main_page_id: e.target.value}))}>
            <option style={{color:"black"}} value="">Selecteaza pagina officiala</option>
            {officialPages.length > 0
              ? officialPages.map(p => <option style={{color:"black"}} key={p.id} value={p.id}>{p.name}</option>)
              : pages.map(p => <option style={{color:"black"}} key={p.id} value={p.id}>{p.name}</option>)
            }
          </select>
        )}
      </div>

      <PageGroup title="SUPPORT — amplificare" icon="👥" color="#86efac" pages={supportPages}
        selectedIds={data.page_ids} onToggle={togglePage}
        delay={data.support_delay_minutes || 10}
        onDelayChange={v => setData(prev => ({...prev, support_delay_minutes: v}))} showDelay={true} />

      <PageGroup title="THEMATIC — context" icon="📰" color="#c4b5fd" pages={thematicPages}
        selectedIds={data.page_ids} onToggle={togglePage}
        delay={data.thematic_delay_minutes || 30}
        onDelayChange={v => setData(prev => ({...prev, thematic_delay_minutes: v}))} showDelay={true} />

      <PageGroup title="REACTION — contra-atac" icon="⚔️" color="#fca5a5" pages={reactionPages}
        selectedIds={data.page_ids} onToggle={togglePage}
        delay={data.reaction_delay_minutes || 60}
        onDelayChange={v => setData(prev => ({...prev, reaction_delay_minutes: v}))} showDelay={true} />
    </div>
  );
};

const MediaUpload = ({ campaignId, pageId, onPublish, showPublish, disabled }) => {
  const [media, setMedia] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const fileRef = useRef(null);

  useEffect(() => { fetchMedia(); }, [campaignId, pageId]);

  const fetchMedia = async () => {
    const url = pageId ? `${API}/campaigns/${campaignId}/media?page_id=${pageId}` : `${API}/campaigns/${campaignId}/media`;
    const res = await axios.get(url);
    setMedia(res.data.media);
  };

  const uploadFiles = async (files) => {
    setUploading(true);
    setUploadProgress(0);
    const formData = new FormData();
    for (const file of files) formData.append("files", file);
    const url = pageId ? `${API}/campaigns/${campaignId}/upload-media?page_id=${pageId}` : `${API}/campaigns/${campaignId}/upload-media`;
    try {
      await axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 180000,
        onUploadProgress: (e) => {
          if (e.total) setUploadProgress(Math.round((e.loaded * 100) / e.total));
        }
      });
      await fetchMedia();
    } catch (err) {
      console.error("Upload media error:", err);
      try { await fetchMedia(); } catch (_) {}
      const isTimeout = err.code === 'ECONNABORTED' || /timeout/i.test(err.message || '');
      alert(isTimeout
        ? "Upload-ul a durat prea mult (conexiune lentă). Unele poze poate au fost încărcate — verifică lista de mai jos și reîncarcă doar ce lipsește."
        : "Eroare de rețea la încărcare. Unele poze poate au fost încărcate — verifică lista de mai jos și reîncarcă doar ce lipsește.");
    } finally {
      setUploading(false);
      setUploadProgress(0);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const deleteMedia = async (mediaId) => {
    await axios.delete(`${API}/campaigns/${campaignId}/media/${mediaId}`);
    await fetchMedia();
  };

  return (
    <div className="mt-3 pt-3" style={{borderTop:"1px solid rgba(255,255,255,0.06)"}}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>Media ({media.length})</span>
        <div className="flex gap-2">
          <input type="file" ref={fileRef} className="hidden" multiple accept="image/*,video/*"
            onChange={e => uploadFiles(Array.from(e.target.files))} />
          {!disabled && (
            uploading ? (
              <div className="flex items-center gap-2">
                <span className="text-xs" style={{color:"rgba(255,255,255,0.5)"}}>
                  {uploadProgress}%
                </span>
                <div className="w-20 rounded-full h-1" style={{background:"rgba(255,255,255,0.06)"}}>
                  <div className="h-1 rounded-full transition-all" style={{
                    width: `${uploadProgress}%`,
                    background:"linear-gradient(135deg,#6366f1,#8b5cf6)"
                  }}></div>
                </div>
              </div>
            ) : (
              <button onClick={() => fileRef.current.click()}
                className="px-2.5 py-1 rounded-lg text-xs" style={btnGray}>
                + Media
              </button>
            )
          )}
          {showPublish && (
            <button onClick={onPublish} className="px-2.5 py-1 rounded-lg text-xs" style={btnGreen}>Publica cu media</button>
          )}
        </div>
      </div>
      {media.length > 0 && (
        <div className="flex gap-2 flex-wrap">
          {media.map(m => (
            <div key={m.id} className="relative">
              {m.media_type === 'photo' ? (
                <img src={`${process.env.REACT_APP_BASE || "https://www.vilaro.ro"}/uploads/campaigns/${m.file_path.split('/').pop()}`}
                  alt={m.filename} className="w-14 h-14 object-cover rounded-lg" />
              ) : (
                <video src={`${process.env.REACT_APP_BASE || "https://www.vilaro.ro"}/uploads/campaigns/${m.file_path.split('/').pop()}`}
                  className="w-14 h-14 object-cover rounded-lg" muted playsInline />
              )}
              <button onClick={() => deleteMedia(m.id)}
                className="absolute -top-1 -right-1 w-4 h-4 rounded-full flex items-center justify-center text-xs"
                style={{background:"#ef4444", color:"white"}}>×</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


function CalendarView({ campaigns, onSlotClick, onCampaignClick }) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [selectedDay, setSelectedDay] = useState(null);
  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const today = new Date();
  const monthNames = ["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"];
  const dayNames = ["Lun","Mar","Mie","Joi","Vin","Sam","Dum"];
  const dayNamesMobile = ["L","M","M","J","V","S","D"];

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const days = [];
    let startDow = firstDay.getDay();
    if (startDow === 0) startDow = 7;
    for (let i = startDow - 1; i > 0; i--) {
      days.push({ date: new Date(year, month, 1 - i), currentMonth: false });
    }
    for (let i = 1; i <= lastDay.getDate(); i++) {
      days.push({ date: new Date(year, month, i), currentMonth: true });
    }
    const remaining = 42 - days.length;
    for (let i = 1; i <= remaining; i++) {
      days.push({ date: new Date(year, month + 1, i), currentMonth: false });
    }
    return days;
  };

  const getDaysInWeek = (date) => {
    const dow = date.getDay();
    const monday = new Date(date);
    monday.setDate(date.getDate() - (dow === 0 ? 6 : dow - 1));
    const days = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(monday);
      d.setDate(monday.getDate() + i);
      days.push({ date: d, currentMonth: d.getMonth() === date.getMonth() });
    }
    return days;
  };

  const days = getDaysInMonth(currentDate);

  const getCampaignsForDay = (date) => {
    return campaigns.filter(c => {
      const s = c.t0_scheduled_at || c.created_at;
      if (!s || typeof s !== "string") return false;
      const scheduled = new Date(s.includes("Z") || s.includes("+") ? s : s.replace(" ", "T") + "Z");
      if (isNaN(scheduled.getTime())) return false;
      return scheduled.getFullYear() === date.getFullYear() &&
             scheduled.getMonth() === date.getMonth() &&
             scheduled.getDate() === date.getDate();
    }).sort((a, b) => {
      const sa = a.t0_scheduled_at || a.created_at || "";
      const sb = b.t0_scheduled_at || b.created_at || "";
      return new Date(sa.includes("Z") || sa.includes("+") ? sa : sa.replace(" ", "T") + "Z") -
             new Date(sb.includes("Z") || sb.includes("+") ? sb : sb.replace(" ", "T") + "Z");
    });
  };

  const isToday = (date) => {
    return date.getFullYear() === today.getFullYear() &&
           date.getMonth() === today.getMonth() &&
           date.getDate() === today.getDate();
  };

  const prevPeriod = () => {
    const d = new Date(currentDate);
    if (isMobile) d.setDate(d.getDate() - 7);
    else d.setMonth(d.getMonth() - 1);
    setCurrentDate(d);
  };

  const nextPeriod = () => {
    const d = new Date(currentDate);
    if (isMobile) d.setDate(d.getDate() + 7);
    else d.setMonth(d.getMonth() + 1);
    setCurrentDate(d);
  };

  const handleDayClick = (date) => {
    setSelectedDay(date);
  };

  const handleSlotClick = (date, hour) => {
    const dt = new Date(date);
    dt.setHours(hour, 0, 0, 0);
    onSlotClick(dt);
  };

  const statusColors = {
    draft: "rgba(255,255,255,0.4)",
    active: "#22c55e",
    scheduled: "#f59e0b",
    completed: "#6366f1",
  };

  return (
    <div className="rounded-2xl overflow-hidden" style={{...card, border:"1px solid rgba(99,102,241,0.2)"}}>
      <div className="flex items-center justify-between px-4 py-4 flex-wrap gap-3" style={{borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
        <div className="flex items-center gap-2">
          <button onClick={prevPeriod} className="w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold" style={btnGray}>←</button>
          <button onClick={nextPeriod} className="w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold" style={btnGray}>→</button>
          <h3 className="text-base font-bold text-white">
            {isMobile
              ? days[0].date.getDate() + " — " + days[6].date.getDate() + " " + monthNames[days[6].date.getMonth()] + " " + days[6].date.getFullYear()
              : monthNames[currentDate.getMonth()] + " " + currentDate.getFullYear()
            }
          </h3>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={() => setCurrentDate(new Date())} className="px-3 py-1.5 rounded-lg text-xs font-medium" style={btnGray}>Azi</button>
          <div className="hidden md:flex items-center gap-3 text-xs" style={{color:"rgba(255,255,255,0.3)"}}>
            <span className="flex items-center gap-1"><span style={{width:8,height:8,borderRadius:"50%",background:"#22c55e",display:"inline-block"}}></span>Active</span>
            <span className="flex items-center gap-1"><span style={{width:8,height:8,borderRadius:"50%",background:"#f59e0b",display:"inline-block"}}></span>Programate</span>
            <span className="flex items-center gap-1"><span style={{width:8,height:8,borderRadius:"50%",background:"rgba(255,255,255,0.3)",display:"inline-block"}}></span>Draft</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-7" style={{borderBottom:"1px solid rgba(255,255,255,0.06)"}}>
        {(isMobile ? dayNamesMobile : dayNames).map((day, i) => (
          <div key={i} className="py-2 text-center text-xs font-semibold" style={{color:"rgba(255,255,255,0.3)"}}>
            {day}
          </div>
        ))}
      </div>

      {selectedDay && (
        <div className="p-4">
          <div className="flex items-center gap-3 mb-4">
            <button onClick={() => setSelectedDay(null)} className="px-3 py-1.5 rounded-xl text-xs font-medium" style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.08)",color:"rgba(255,255,255,0.7)"}}>← Luna</button>
            <h4 className="text-white font-semibold">
              {selectedDay.toLocaleDateString("ro-RO", {weekday:"long", day:"numeric", month:"long", year:"numeric"})}
            </h4>
            <button onClick={() => handleSlotClick(selectedDay, 10)} className="ml-auto px-3 py-1.5 rounded-xl text-xs font-semibold" style={{background:"linear-gradient(135deg,#6366f1,#8b5cf6)",color:"white"}}>+ Campanie noua</button>
          </div>
          {getCampaignsForDay(selectedDay).length === 0 ? (
            <div className="text-center py-12" style={{color:"rgba(255,255,255,0.2)"}}>
              <p className="text-4xl mb-3">📅</p>
              <p className="text-sm">Nicio campanie in aceasta zi</p>
              <button onClick={() => handleSlotClick(selectedDay, 10)} className="mt-4 px-4 py-2 rounded-xl text-sm font-semibold" style={{background:"linear-gradient(135deg,#6366f1,#8b5cf6)",color:"white"}}>+ Creeaza campanie</button>
            </div>
          ) : (
            <div className="space-y-3">
              {getCampaignsForDay(selectedDay).map(c => {
                const s = c.t0_scheduled_at || c.created_at;
                const scheduled = s ? new Date(s.includes("Z") || s.includes("+") ? s : s.replace(" ", "T") + "Z") : null;
                const hour = scheduled ? scheduled.toLocaleTimeString("ro-RO", {hour:"2-digit", minute:"2-digit"}) : "";
                const color = statusColors[c.status] || "rgba(255,255,255,0.3)";
                return (
                  <div key={c.id} onClick={() => onCampaignClick(c)} className="rounded-2xl p-4 cursor-pointer transition-all"
                    style={{background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.08)"}}>
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center gap-2">
                        <span style={{color, fontSize:10}}>●</span>
                        <span className="text-white font-semibold text-sm">{c.title}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-xs px-2 py-0.5 rounded-full" style={{background:color+"20",color}}>{c.status}</span>
                        {hour && <span className="text-xs font-medium" style={{color:"rgba(255,255,255,0.4)"}}>{hour}</span>}
                      </div>
                    </div>
                    {c.context && <p className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>{c.context.substring(0,100)}{c.context.length>100?"...":""}</p>}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {!selectedDay && <div className="grid grid-cols-7" style={{minHeight: isMobile ? "320px" : "520px"}}>
        {days.map((day, i) => {
          const dayCampaigns = getCampaignsForDay(day.date);
          const isCurrentDay = isToday(day.date);
          const maxShow = isMobile ? 1 : 3;
          return (
            <div
              key={i}
              onClick={() => handleDayClick(day.date)}
              className="cursor-pointer transition-all"
              style={{
                borderRight: (i + 1) % 7 !== 0 ? "1px solid rgba(255,255,255,0.04)" : "none",
                borderBottom: i < days.length - 7 ? "1px solid rgba(255,255,255,0.04)" : "none",
                background: isCurrentDay ? "rgba(99,102,241,0.08)" : "transparent",
                opacity: !day.currentMonth ? 0.35 : 1,
                padding: isMobile ? "4px 2px" : "8px 6px",
              }}
            >
              <div className="flex items-center justify-center mb-1">
                <span className="w-6 h-6 flex items-center justify-center rounded-full text-xs"
                  style={{
                    background: isCurrentDay ? "#6366f1" : "transparent",
                    color: isCurrentDay ? "white" : "rgba(255,255,255,0.7)",
                    fontWeight: isCurrentDay ? "bold" : "normal",
                  }}>
                  {day.date.getDate()}
                </span>
              </div>
              <div className="space-y-1">
                {dayCampaigns.slice(0, maxShow).map(c => {
                  const s = c.t0_scheduled_at || c.created_at;
                  if (!s || typeof s !== "string") return null;
                  const scheduled = new Date(s.includes("Z") || s.includes("+") ? s : s.replace(" ", "T") + "Z");
                  const hour = scheduled.toLocaleTimeString("ro-RO", {hour:"2-digit", minute:"2-digit"});
                  const color = statusColors[c.status] || "rgba(255,255,255,0.3)";
                  return (
                    <div key={c.id}
                      onClick={e => { e.stopPropagation(); onCampaignClick(c); }}
                      className="rounded px-1 py-0.5 cursor-pointer"
                      style={{background: color + "25", border: "1px solid " + color + "60"}}>
                      {!isMobile && (
                        <div style={{color:"rgba(255,255,255,0.4)", fontSize:9}}>{hour}</div>
                      )}
                      <div className="truncate font-medium" style={{fontSize: isMobile ? 9 : 11, color:"rgba(255,255,255,0.85)"}}>
                        <span style={{color, marginRight:3, fontSize:8}}>●</span>{c.title}
                      </div>
                    </div>
                  );
                })}
                {dayCampaigns.length > maxShow && (
                  <div className="text-center" style={{color:"rgba(255,255,255,0.3)", fontSize:10}}>
                    +{dayCampaigns.length - maxShow}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>}
    </div>
  );
}

export default function Campaigns() {
  const [campaigns, setCampaigns] = useState([]);
  const [pages, setPages] = useState([]);
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [viewMode, setViewMode] = useState("lista");
  const [prevViewMode, setPrevViewMode] = useState("lista");
  const [editMode, setEditMode] = useState(false);
  const [editPostMode, setEditPostMode] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [newCampaign, setNewCampaign] = useState({
    title:"", context:"", key_points:"", main_page_id:"", page_ids:[], domain_id:"",
    t0_scheduled_at:"", support_delay_minutes:10, thematic_delay_minutes:30, reaction_delay_minutes:60
  });
  const [editCampaign, setEditCampaign] = useState(null);
  const [editPostText, setEditPostText] = useState("");
  const [editingVariant, setEditingVariant] = useState(null); // page_id
  const [editVariantText, setEditVariantText] = useState("");
  const [generating, setGenerating] = useState(false);
  const [message, setMessage] = useState("");
  const [publishingAll, setPublishingAll] = useState(false);
  const [publishingMain, setPublishingMain] = useState(false);
  const [publishProgress, setPublishProgress] = useState({current: 0, total: 0, published: 0, page_name: ""});
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(null);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("08:00");
  const [scheduleDelays, setScheduleDelays] = useState({support: 10, thematic: 30, reaction: 60});
  const [deleteFromFb, setDeleteFromFb] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [warnModal, setWarnModal] = useState("");

  useEffect(() => { fetchAll(); }, []);

  // Polling cand exista campanii scheduled
  useEffect(() => {
    const hasScheduled = campaigns.some(c => 
      c.main_post_status === 'scheduled' || c.status === 'active'
    );
    if (!hasScheduled) return;
    const poll = setInterval(async () => {
      await fetchCampaigns();
      if (selectedCampaign) {
        const res = await axios.get(`${API}/campaigns/${selectedCampaign.id}`);
        setSelectedCampaign(res.data);
      }
    }, 30000); // 30 secunde
    return () => clearInterval(poll);
  }, [campaigns, selectedCampaign]);

  const fetchAll = async () => {
    await Promise.all([fetchCampaigns(), fetchPages(), fetchDomains()]);
    setLoading(false);
  };

  const fetchCampaigns = async () => { const res = await axios.get(`${API}/campaigns`); setCampaigns(res.data.campaigns); };
  const fetchPages = async () => { const res = await axios.get(`${API}/pages`); setPages(res.data.pages.filter(p => p.is_active)); };
  const fetchDomains = async () => { const res = await axios.get(`${API}/domains`); setDomains(res.data.domains); };

  const fetchCampaign = async (id) => {
    const res = await axios.get(`${API}/campaigns/${id}`);
    setSelectedCampaign(res.data);
    setEditMode(false);
    setEditPostMode(false);
  };

  const createCampaign = async () => {
    if (!newCampaign.title.trim()) {
      setWarnModal("Completează titlul campaniei înainte de a continua.");
      return;
    }
    if (!newCampaign.main_page_id) {
      setWarnModal("Selectează pagina principală (OFFICIAL) înainte de a crea campania.");
      return;
    }
    await axios.post(`${API}/campaigns`, {...newCampaign, domain_id: newCampaign.domain_id || null, t0_scheduled_at: null});
    await fetchCampaigns();
    setShowCreate(false);
    setNewCampaign({ title:"", context:"", key_points:"", main_page_id:"", page_ids:[], domain_id:"", t0_scheduled_at:"", support_delay_minutes:10, thematic_delay_minutes:30, reaction_delay_minutes:60 });
  };

  const updateCampaign = async () => {
    await axios.put(`${API}/campaigns/${editCampaign.id}`, {
      title: editCampaign.title, context: editCampaign.context,
      key_points: editCampaign.key_points, main_page_id: editCampaign.main_page_id,
      domain_id: editCampaign.domain_id || null, page_ids: editCampaign.page_ids,
      t0_scheduled_at: editCampaign.t0_scheduled_at || null,
      support_delay_minutes: editCampaign.support_delay_minutes || 10,
      thematic_delay_minutes: editCampaign.thematic_delay_minutes || 30,
      reaction_delay_minutes: editCampaign.reaction_delay_minutes || 60
    });
    await fetchCampaigns();
    await fetchCampaign(editCampaign.id);
  };

  const updateMainPost = async () => {
    await axios.put(`${API}/campaigns/${selectedCampaign.id}/main-post`, { main_post_text: editPostText });
    await fetchCampaign(selectedCampaign.id);
  };

  const deleteCampaign = async (id) => {
    setDeleting(true);
    await axios.delete(`${API}/campaigns/${id}?delete_from_fb=${deleteFromFb}`);
    if (selectedCampaign?.id === id) setSelectedCampaign(null);
    setShowDeleteConfirm(null);
    setDeleteFromFb(false);
    setDeleting(false);
    await fetchCampaigns();
  };

  const startEdit = () => {
    setEditCampaign({
      id: selectedCampaign.id, title: selectedCampaign.title,
      context: selectedCampaign.context, key_points: selectedCampaign.key_points,
      main_page_id: selectedCampaign.main_page_id,
      domain_id: selectedCampaign.domain_id ? String(selectedCampaign.domain_id) : "",
      page_ids: selectedCampaign.pages?.map(p => p.page_id) || [],
      locked: selectedCampaign.status === 'active',
      t0_scheduled_at: selectedCampaign.t0_scheduled_at || "",
      support_delay_minutes: selectedCampaign.support_delay_minutes || 10,
      thematic_delay_minutes: selectedCampaign.thematic_delay_minutes || 30,
      reaction_delay_minutes: selectedCampaign.reaction_delay_minutes || 60
    });
    setEditMode(true);
    setEditPostMode(false);
  };

  const generateVariant = async (pageId) => {
    setGenerating(true);
    await axios.post(`${API}/campaigns/${selectedCampaign.id}/generate-variant/${pageId}`);
    await fetchCampaign(selectedCampaign.id);
    setGenerating(false);
  };

  const disapproveMainPost = async (id) => {
    await axios.post(`${API}/campaigns/${id}/disapprove-main-post`);
    await fetchCampaign(id);
  };

  const disapproveVariant = async (pageId) => {
    await axios.post(`${API}/campaigns/${selectedCampaign.id}/disapprove-variant/${pageId}`);
    await fetchCampaign(selectedCampaign.id);
  };

  const saveVariant = async (pageId) => {
    await axios.put(`${API}/campaigns/${selectedCampaign.id}/variant/${pageId}`, { variant_text: editVariantText });
    setEditingVariant(null);
    await fetchCampaign(selectedCampaign.id);
  };

  const startEditPost = () => {
    setEditPostText(selectedCampaign.main_post_text || "");
    setEditPostMode(true);
    setEditMode(false);
  };

  const generateMainPost = async (id) => { setGenerating(true); await axios.post(`${API}/campaigns/${id}/generate-main-post`); await fetchCampaign(id); setGenerating(false); };
  const approveMainPost = async (id) => { await axios.post(`${API}/campaigns/${id}/approve-main-post`); await fetchCampaign(id); };
  const generateVariants = async (id) => { setGenerating(true); setMessage("Generez variante..."); await axios.post(`${API}/campaigns/${id}/generate`); await fetchCampaign(id); setGenerating(false); setMessage(""); };
  const approveAll = async (id) => { await axios.post(`${API}/campaigns/${id}/approve-all`); await fetchCampaign(id); };
  const publishMainPost = async (id) => {
    if (!selectedCampaign.main_page_id) {
      setWarnModal("Campania nu are pagină principală selectată. Editează campania și selectează o pagină OFFICIAL.");
      return;
    }
    setPublishingMain(true);
    try {
      await axios.post(`${API}/campaigns/${id}/publish-main-post`);
      await fetchCampaigns();
      await fetchCampaign(id);
    } catch (err) {
      const detail = err?.response?.data?.detail || err?.message || "Eroare necunoscută";
      setWarnModal("Publicarea a eșuat: " + detail);
      console.error("publishMainPost error:", err);
    } finally {
      setPublishingMain(false);
    }
  };
  const publishVariantWithMedia = async (campaignId, pageId) => { await axios.post(`${API}/campaigns/${campaignId}/publish-with-media/${pageId}`); await fetchCampaign(campaignId); };

  const publishAll = async (id) => {
    setPublishingAll(true);
    setPublishProgress({current: 0, total: 0, published: 0, page_name: ""});
    await axios.post(`${API}/campaigns/${id}/publish-all`);
    await new Promise(r => setTimeout(r, 500));
    const poll = setInterval(async () => {
      const res = await axios.get(`${API}/campaigns/${id}/publish-all-status`);
      const status = res.data;
      setPublishProgress(status);
      if (status.finished === true) {
        clearInterval(poll);
        setPublishingAll(false);
        await fetchCampaign(id);
      }
    }, 1000);
  };

  const scheduleCampaign = async () => {
    if (!scheduleDate || !scheduleTime) {
      setWarnModal("Selectează data și ora la care vrei să fie publicată campania.");
      return;
    }
    const approvedPages = selectedCampaign.pages?.filter(p => p.status === 'approved') || [];
    if (approvedPages.length === 0 && selectedCampaign.pages?.length > 0) {
      setWarnModal("Nicio pagină secundară nu este aprobată. Aprobă cel puțin o variantă înainte de programare.");
      return;
    }
    try {
      // Folosim ora locala a utilizatorului - browserul converteste in UTC
      const localDate = new Date(`${scheduleDate}T${scheduleTime}:00`);
      const t0 = localDate.toISOString().slice(0, 16);
      await axios.put(`${API}/campaigns/${selectedCampaign.id}`, {
        title: selectedCampaign.title,
        context: selectedCampaign.context || "",
        key_points: selectedCampaign.key_points || "",
        main_page_id: selectedCampaign.main_page_id,
        domain_id: selectedCampaign.domain_id ? String(selectedCampaign.domain_id) : null,
        page_ids: selectedCampaign.pages?.map(p => p.page_id) || [],
        t0_scheduled_at: t0,
        support_delay_minutes: parseInt(scheduleDelays.support) || 10,
        thematic_delay_minutes: parseInt(scheduleDelays.thematic) || 30,
        reaction_delay_minutes: parseInt(scheduleDelays.reaction) || 60
      });
      await axios.post(`${API}/campaigns/${selectedCampaign.id}/schedule-all`);
      setShowScheduleModal(false);
      await fetchCampaign(selectedCampaign.id);
    } catch(e) {
      alert('Eroare: ' + JSON.stringify(e.response?.data || e.message));
    }
  };

  const getDomain = (domainId) => domainId ? domains.find(d => Number(d.id) === Number(domainId)) : null;
  const getPageType = (pageId) => pages.find(p => p.id === pageId)?.page_type || "support";

  const groupPagesByType = (campaignPages) => ({
    official: campaignPages.filter(p => getPageType(p.page_id) === "official"),
    support: campaignPages.filter(p => getPageType(p.page_id) === "support"),
    thematic: campaignPages.filter(p => getPageType(p.page_id) === "thematic"),
    reaction: campaignPages.filter(p => getPageType(p.page_id) === "reaction"),
  });

  // Campania e gata de programare cand postarea principala si cel putin o varianta sunt aprobate
  const canSchedule = selectedCampaign && 
    selectedCampaign.main_post_status === 'approved';

  // Campania e programata cand postarea principala e scheduled
  const isScheduled = selectedCampaign?.main_post_status === 'scheduled';

  if (loading) return <div style={{color:"rgba(255,255,255,0.4)"}} className="text-sm py-8">Se incarca...</div>;

  return (
    <div>
      {showDeleteConfirm && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:"rgba(0,0,0,0.8)"}}>
          <div className="rounded-2xl p-6 max-w-md w-full mx-4" style={card}>
            <h3 className="text-lg font-bold mb-2 text-white">Sterge campania</h3>
            <p className="text-sm mb-3" style={{color:"rgba(255,255,255,0.5)"}}>
              Esti sigur ca vrei sa stergi <span className="text-white font-semibold">"{showDeleteConfirm.title}"</span>?
            </p>
            <label className="flex items-center gap-2 mb-4 cursor-pointer">
              <input type="checkbox" checked={deleteFromFb} onChange={e => setDeleteFromFb(e.target.checked)} className="accent-red-500" />
              <span className="text-sm" style={{color:"#fca5a5"}}>Sterge si de pe Facebook</span>
            </label>
            <div className="flex gap-3">
              <button onClick={() => deleteCampaign(showDeleteConfirm.id)} disabled={deleting}
                className="flex-1 py-2 rounded-xl text-sm font-medium disabled:opacity-50" style={btnRed}>
                {deleting ? (
                  <div className="flex items-center justify-center gap-2">
                    <span>Se sterge...</span>
                    <div className="w-12 rounded-full h-1" style={{background:"rgba(255,255,255,0.2)"}}>
                      <div className="h-1 rounded-full" style={{width:"60%",background:"#fca5a5",animation:"pulse 1s infinite"}}></div>
                    </div>
                  </div>
                ) : "Sterge"}
              </button>
              <button onClick={() => setShowDeleteConfirm(null)} className="flex-1 py-2 rounded-xl text-sm font-medium" style={btnGray}>Anuleaza</button>
            </div>
          </div>
        </div>
      )}

      {warnModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:"rgba(0,0,0,0.8)"}}>
          <div className="rounded-2xl p-6 max-w-md w-full mx-4" style={card}>
            <div className="flex items-center gap-3 mb-3">
              <span className="text-2xl">⚠️</span>
              <h3 className="text-lg font-bold text-white">Atenție</h3>
            </div>
            <p className="text-sm mb-5" style={{color:"rgba(255,255,255,0.6)"}}>{warnModal}</p>
            <button onClick={() => setWarnModal("")}
              className="w-full py-2.5 rounded-xl text-sm font-medium" style={btnGray}>
              Am înțeles
            </button>
          </div>
        </div>
      )}

      {warnModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:"rgba(0,0,0,0.8)"}}>
          <div className="rounded-2xl p-6 max-w-md w-full mx-4" style={card}>
            <div className="flex items-center gap-3 mb-3">
              <span className="text-2xl">⚠️</span>
              <h3 className="text-lg font-bold text-white">Atenție</h3>
            </div>
            <p className="text-sm mb-5" style={{color:"rgba(255,255,255,0.6)"}}>{warnModal}</p>
            <button onClick={() => setWarnModal("")}
              className="w-full py-2.5 rounded-xl text-sm font-medium" style={btnGray}>
              Am înțeles
            </button>
          </div>
        </div>
      )}

      {showScheduleModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:"rgba(0,0,0,0.8)"}}>
          <div className="rounded-2xl p-6 max-w-md w-full mx-4" style={card}>
            <h3 className="text-lg font-bold mb-2 text-white">📅 Programează campania</h3>
            <p className="text-sm mb-1" style={{color:"rgba(255,255,255,0.4)"}}>"{selectedCampaign?.title}"</p>
            <p className="text-xs mb-4" style={{color:"rgba(255,255,255,0.25)"}}>
              ⏰ Ora ta locală: {new Date().toLocaleTimeString()} ({Intl.DateTimeFormat().resolvedOptions().timeZone})
            </p>

            <div className="space-y-3 mb-4">
              <div>
                <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Data T0</label>
                <input type="date" className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                  value={scheduleDate}
                  onChange={e => setScheduleDate(e.target.value)} />
              </div>
              <div>
                <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Ora T0</label>
                <input type="time" className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                  value={scheduleTime} onChange={e => setScheduleTime(e.target.value)} />
              </div>
            </div>

            <div className="space-y-2 mb-4">
              {[
                {label:"👥 Support", key:"support", color:"#86efac"},
                {label:"📰 Thematic", key:"thematic", color:"#c4b5fd"},
                {label:"⚔️ Reaction", key:"reaction", color:"#fca5a5"},
              ].map(g => (
                <div key={g.key} className="flex items-center justify-between rounded-xl px-3 py-2"
                  style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.06)"}}>
                  <span className="text-xs font-medium" style={{color:g.color}}>{g.label}</span>
                  <div className="flex items-center gap-2">
                    <span className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>T+</span>
                    <input type="number" min="1" max="1440"
                      className="w-16 rounded-lg px-2 py-1 text-xs text-center" style={inputStyle}
                      value={scheduleDelays[g.key]}
                      onChange={e => setScheduleDelays(prev => ({...prev, [g.key]: parseInt(e.target.value) || 0}))} />
                    <span className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>min</span>
                  </div>
                </div>
              ))}
            </div>

            {scheduleDate && scheduleTime && (
              <div className="rounded-xl p-3 mb-4 space-y-1" style={{background:"rgba(99,102,241,0.1)",border:"1px solid rgba(99,102,241,0.2)"}}>
                <p className="text-xs" style={{color:"#a5b4fc"}}>📢 Official: {scheduleDate} {scheduleTime} (ora ta)</p>
                <p className="text-xs" style={{color:"#86efac"}}>👥 Support: T+{scheduleDelays.support} min</p>
                <p className="text-xs" style={{color:"#c4b5fd"}}>📰 Thematic: T+{scheduleDelays.thematic} min</p>
                <p className="text-xs" style={{color:"#fca5a5"}}>⚔️ Reaction: T+{scheduleDelays.reaction} min</p>
              </div>
            )}

            <div className="flex gap-3">
              <button onClick={scheduleCampaign} disabled={!scheduleDate || !scheduleTime}
                className="flex-1 py-2 rounded-xl text-sm font-semibold disabled:opacity-40" style={btnPrimary}>
                Programează
              </button>
              <button onClick={() => setShowScheduleModal(false)}
                className="flex-1 py-2 rounded-xl text-sm font-medium" style={btnGray}>
                Anulează
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-between items-center mb-6 flex-wrap gap-3">
        <div>
          <h2 className="text-2xl font-bold text-white">Campanii</h2>
          <p className="text-sm mt-0.5" style={{color:"rgba(255,255,255,0.35)"}}>Orchestreaza mesajul public</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <div className="flex rounded-xl overflow-hidden" style={{border:"1px solid rgba(255,255,255,0.08)"}}>
            <button onClick={() => setViewMode("lista")} className="px-3 py-2 text-xs font-medium transition-all" style={viewMode === "lista" ? btnPrimary : btnGray}>☰ Lista</button>
            <button onClick={() => setViewMode("calendar")} className="px-3 py-2 text-xs font-medium transition-all" style={viewMode === "calendar" ? btnPrimary : btnGray}>📅 Calendar</button>
          </div>
          <button onClick={() => { setShowCreate(true); setViewMode("lista"); }} className="px-4 py-2 rounded-xl text-sm font-semibold" style={btnPrimary}>+ Campanie noua</button>
        </div>
      </div>

      {message && (
        <div className="rounded-xl p-3 mb-4 text-sm" style={{background:"rgba(99,102,241,0.15)", border:"1px solid rgba(99,102,241,0.3)", color:"#a5b4fc"}}>
          {message}
        </div>
      )}

      {showCreate && (
        <div className="rounded-2xl p-6 mb-6" style={card}>
          <h3 className="text-lg font-semibold mb-4 text-white">Campanie nouă</h3>
          <FormFields data={newCampaign} setData={setNewCampaign} pages={pages} domains={domains} />
          <div className="flex gap-2 mt-4">
            <button onClick={createCampaign} className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>Creeaza</button>
            <button onClick={() => { setShowCreate(false); setViewMode(prevViewMode); setPrevViewMode("lista"); }} className="px-4 py-2 rounded-xl text-sm font-medium" style={btnGray}>Anuleaza</button>
          </div>
        </div>
      )}

      {viewMode === "calendar" && (
        <CalendarView
          campaigns={campaigns}
          onSlotClick={(dt) => {
            const pad = n => String(n).padStart(2, "0");
            const dateStr = dt.getFullYear() + "-" + pad(dt.getMonth()+1) + "-" + pad(dt.getDate());
            const timeStr = pad(dt.getHours()) + ":" + pad(dt.getMinutes());
            setScheduleDate(dateStr);
            setScheduleTime(timeStr);
            setPrevViewMode("calendar");
            setShowCreate(true);
            setViewMode("lista");
          }}
          onCampaignClick={(c) => {
            fetchCampaign(c.id);
            setViewMode("lista");
          }}
        />
      )}
      {viewMode === "lista" && (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="col-span-1 space-y-2" style={{display: typeof window !== "undefined" && window.innerWidth < 768 && selectedCampaign ? "none" : "block"}}>
          {campaigns.length === 0 && (
            <div className="text-center py-12 text-sm" style={{color:"rgba(255,255,255,0.25)"}}>Nicio campanie creată.</div>
          )}
          {campaigns.map(c => {
            const domain = getDomain(c.domain_id);
            const isSelected = selectedCampaign?.id === c.id;
            return (
              <div key={c.id} className="rounded-xl p-4 cursor-pointer transition-all"
                style={isSelected ? {...card, border:"1px solid rgba(99,102,241,0.4)", background:"rgba(99,102,241,0.06)"} : card}>
                <div onClick={() => fetchCampaign(c.id)}>
                  <div className="flex justify-between items-start mb-1.5">
                    <h3 className="font-semibold text-sm text-white leading-tight">{c.title}</h3>
                    <span className="text-xs px-2 py-0.5 rounded-full ml-2 flex-shrink-0" style={statusColors[c.status]}>{c.status}</span>
                  </div>
                  {domain && (
                    <div className="flex items-center gap-1.5 mb-1">
                      <div className="w-1.5 h-1.5 rounded-full" style={{backgroundColor: domain.color}}></div>
                      <span className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>{domain.name}</span>
                    </div>
                  )}
                  <p className="text-xs" style={{color:"rgba(255,255,255,0.25)"}}>{c.page_count} pagini · {new Date(c.created_at).toLocaleDateString('ro-RO')}</p>
                </div>
                <div className="flex justify-end mt-2">
                  <button onClick={e => { e.stopPropagation(); setShowDeleteConfirm(c); }}
                    className="text-xs px-2 py-1 rounded-lg" style={{color:"rgba(239,68,68,0.6)"}}>
                    Sterge
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {selectedCampaign && !editMode && (
          <div className="col-span-1 md:col-span-2 rounded-2xl p-6" style={card}>
            <div className="mb-3 md:hidden">
              <button onClick={() => setSelectedCampaign(null)} className="text-xs px-3 py-1.5 rounded-xl" style={{background:"rgba(255,255,255,0.06)",color:"rgba(255,255,255,0.6)"}}>← Inapoi</button>
            </div>
            <div className="mb-3">
              <button onClick={() => setSelectedCampaign(null)} className="px-3 py-1.5 rounded-xl text-xs" style={btnGray}>← Inapoi</button>
            </div>
            <div className="flex justify-between items-start mb-4">
              <div>
                {getDomain(selectedCampaign.domain_id) && (
                  <div className="flex items-center gap-1.5 mb-1">
                    <div className="w-2 h-2 rounded-full" style={{backgroundColor: getDomain(selectedCampaign.domain_id).color}}></div>
                    <span className="text-xs" style={{color:"rgba(255,255,255,0.4)"}}>{getDomain(selectedCampaign.domain_id).name}</span>
                  </div>
                )}
                <h3 className="text-xl font-bold text-white">{selectedCampaign.title}</h3>
                <p className="text-sm mt-1" style={{color:"rgba(255,255,255,0.4)"}}>{selectedCampaign.context}</p>
              </div>
              <div className="flex gap-2">
                {canSchedule && (
                  <button onClick={() => {
                    setShowScheduleModal(true);
                    if (!scheduleDate) setScheduleDate("");
                    if (!scheduleTime) setScheduleTime("08:00");
                    setScheduleDelays({
                      support: selectedCampaign.support_delay_minutes || 10,
                      thematic: selectedCampaign.thematic_delay_minutes || 30,
                      reaction: selectedCampaign.reaction_delay_minutes || 60
                    });
                  }} className="px-3 py-1.5 rounded-xl text-xs font-medium" style={btnYellow}>
                    📅 Programează
                  </button>
                )}
                {isScheduled && (
                  <span className="px-3 py-1.5 rounded-xl text-xs font-medium" style={{background:"rgba(234,179,8,0.15)",color:"#fde047"}}>
                    ⏳ Programat {selectedCampaign.t0_scheduled_at ? new Date(selectedCampaign.t0_scheduled_at + 'Z').toLocaleString() : ''}
                  </span>
                )}
                <button onClick={startEdit} className="px-3 py-1.5 rounded-xl text-xs font-medium" style={btnGray}>Editeaza</button>
              </div>
            </div>

            {/* Postarea principala */}
            <div className="rounded-xl p-4 mb-4" style={{background:"rgba(99,102,241,0.05)", border:"1px solid rgba(99,102,241,0.3)"}}>
              <div className="flex justify-between items-center mb-3">
                <div>
                  <span className="text-xs font-semibold" style={{color:"#a5b4fc"}}>📢 OFFICIAL — T0</span>
                  {selectedCampaign.main_page && (
                    <span className="text-xs ml-2" style={{color:"rgba(255,255,255,0.4)"}}>— {selectedCampaign.main_page.name}</span>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xs px-2 py-0.5 rounded-full" style={postStatusColors[selectedCampaign.main_post_status] || postStatusColors.empty}>
                    {selectedCampaign.main_post_status}
                  </span>
                  {selectedCampaign.main_post_status === 'approved' && !selectedCampaign.main_post_fb_id && !isScheduled && (
                    publishingMain ? (
                      <div className="flex items-center gap-2">
                        <span className="text-xs" style={{color:"#86efac"}}>Se publică...</span>
                        <div className="w-16 rounded-full h-1" style={{background:"rgba(255,255,255,0.06)"}}>
                          <div className="h-1 rounded-full" style={{
                            width:"60%",
                            background:"linear-gradient(135deg,#22c55e,#16a34a)",
                            animation:"pulse 1s infinite"
                          }}></div>
                        </div>
                      </div>
                    ) : (
                      <button onClick={() => publishMainPost(selectedCampaign.id)}
                        className="px-2 py-1 rounded-lg text-xs font-medium" style={btnGreen}>
                        Publică
                      </button>
                    )
                  )}
                  {selectedCampaign.main_post_fb_id && (
                    <span className="text-xs" style={{color:"#86efac"}}>✓ Publicat</span>
                  )}
                </div>
              </div>
              {editPostMode ? (
                <div className="mb-3">
                  <TextEditor value={editPostText} onChange={setEditPostText} rows={8} />
                  <div className="flex gap-2 mt-2">
                    <button onClick={updateMainPost}
                      className="px-3 py-1.5 rounded-lg text-xs font-medium" style={btnGreen}>
                      Salveaza
                    </button>
                    <button onClick={() => setEditPostMode(false)}
                      className="px-3 py-1.5 rounded-lg text-xs" style={btnGray}>
                      Anuleaza
                    </button>
                  </div>
                </div>
              ) : selectedCampaign.main_post_text ? (
                <p className="text-sm whitespace-pre-wrap mb-3" style={{color:"rgba(255,255,255,0.7)"}}>{selectedCampaign.main_post_text}</p>
              ) : (
                <p className="text-sm italic mb-3" style={{color:"rgba(255,255,255,0.25)"}}>Nicio postare generata inca</p>
              )}
              <MediaUpload campaignId={selectedCampaign.id} pageId={null} showPublish={false}
                disabled={['approved','posted','scheduled'].includes(selectedCampaign.main_post_status)} />
              <div className="flex flex-wrap gap-2 mt-3">
                {!isScheduled && !['approved','posted','scheduled'].includes(selectedCampaign.main_post_status) && (
                  <>
                    <button onClick={() => generateMainPost(selectedCampaign.id)} disabled={generating}
                      className="px-3 py-1.5 rounded-xl text-xs font-medium disabled:opacity-50" style={btnPurple}>
                      ✨ Genereaza AI
                    </button>
                    <button onClick={startEditPost}
                      className="px-3 py-1.5 rounded-xl text-xs font-medium" style={btnGray}>
                      ✏️ {selectedCampaign.main_post_text ? 'Editeaza' : 'Scrie manual'}
                    </button>
                  </>
                )}
                {selectedCampaign.main_post_text && !['approved','posted','scheduled'].includes(selectedCampaign.main_post_status) && (
                  <button onClick={() => approveMainPost(selectedCampaign.id)}
                    className="px-3 py-1.5 rounded-xl text-xs font-medium"
                    style={{background:"rgba(99,102,241,0.15)",border:"1px solid rgba(99,102,241,0.3)",color:"#a5b4fc"}}>
                    Aproba
                  </button>
                )}
                {selectedCampaign.main_post_status === 'approved' && !selectedCampaign.main_post_fb_id && !isScheduled && (
                  <button onClick={() => disapproveMainPost(selectedCampaign.id)}
                    className="px-3 py-1.5 rounded-xl text-xs font-medium" style={btnRed}>
                    ↩️ Dezaproba
                  </button>
                )}
              </div>
            </div>

            {/* Variante grupate pe tip */}
            {selectedCampaign.pages?.length > 0 && (() => {
              const grouped = groupPagesByType(selectedCampaign.pages);
              const groups = [
                { key: "support", label: "SUPPORT — amplificare", icon: "👥", color: "#86efac", delay: selectedCampaign.support_delay_minutes || 10, pages: grouped.support },
                { key: "thematic", label: "THEMATIC — context", icon: "📰", color: "#c4b5fd", delay: selectedCampaign.thematic_delay_minutes || 30, pages: grouped.thematic },
                { key: "reaction", label: "REACTION — contra-atac", icon: "⚔️", color: "#fca5a5", delay: selectedCampaign.reaction_delay_minutes || 60, pages: grouped.reaction },
              ].filter(g => g.pages.length > 0);

              const hasApproved = selectedCampaign.pages.some(p => p.status === 'approved');
              const hasScheduled = selectedCampaign.pages.some(p => p.status === 'scheduled');
              const hasPending = selectedCampaign.pages.some(p => p.status === 'pending');
              const hasGenerated = selectedCampaign.pages.some(p => p.status === 'generated');

              return (
                <div className="space-y-4">
                  <div className="flex justify-between items-center">
                    <h4 className="font-semibold text-sm text-white">Variante per pagina</h4>
                    <div className="flex gap-2">
                      {!isScheduled && selectedCampaign.main_post_status === 'approved' && hasPending && (
                        <button onClick={() => generateVariants(selectedCampaign.id)} disabled={generating}
                          className="px-3 py-1.5 rounded-xl text-xs font-medium disabled:opacity-50" style={btnPurple}>
                          ✨ Genereaza toate
                        </button>
                      )}
                      {!isScheduled && (hasGenerated || hasPending) && (
                        <button onClick={() => approveAll(selectedCampaign.id)}
                          className="px-3 py-1.5 rounded-xl text-xs font-medium"
                          style={{background:"rgba(99,102,241,0.15)",border:"1px solid rgba(99,102,241,0.3)",color:"#a5b4fc"}}>
                          Aproba toate
                        </button>
                      )}
                      {!isScheduled && hasApproved && (
                        publishingAll ? (
                          <div className="flex items-center gap-2">
                            <span className="text-xs" style={{color:"#86efac"}}>
                              {publishProgress.page_name || "Se publică..."} {publishProgress.current}/{publishProgress.total}
                            </span>
                            <div className="w-20 rounded-full h-1" style={{background:"rgba(255,255,255,0.06)"}}>
                              <div className="h-1 rounded-full transition-all" style={{
                                width: publishProgress.total > 0 ? `${Math.round((publishProgress.current/publishProgress.total)*100)}%` : "5%",
                                background:"linear-gradient(135deg,#22c55e,#16a34a)"
                              }}></div>
                            </div>
                          </div>
                        ) : (
                          <button onClick={() => {
                            if (!selectedCampaign.main_post_fb_id) {
                              setWarnModal("Publică mai întâi postarea principală (OFFICIAL) înainte de a publica variantele secundare.");
                              return;
                            }
                            publishAll(selectedCampaign.id);
                          }}
                            className="px-3 py-1.5 rounded-xl text-xs font-medium" style={btnGreen}>
                            Publica toate
                          </button>
                        )
                      )}
                    </div>
                  </div>

                  {groups.map(group => (
                    <div key={group.key} className="rounded-xl p-4" style={{background:"rgba(255,255,255,0.02)", border:`1px solid ${group.color}30`}}>
                      <div className="flex items-center gap-2 mb-3">
                        <span className="text-xs font-semibold" style={{color:group.color}}>{group.icon} {group.label}</span>
                        <span className="text-xs px-2 py-0.5 rounded-full" style={{background:"rgba(255,255,255,0.06)",color:"rgba(255,255,255,0.4)"}}>
                          T+{group.delay} min
                          {selectedCampaign.t0_scheduled_at && (
                            <> → {new Date(new Date(selectedCampaign.t0_scheduled_at + 'Z').getTime() + group.delay * 60000).toLocaleTimeString([], {hour:'2-digit',minute:'2-digit'})}</>
                          )}
                        </span>
                      </div>
                      <div className="space-y-3">
                        {group.pages.map(page => (
                          <div key={page.page_id} className="rounded-xl p-3" style={{background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.05)"}}>
                            <div className="flex justify-between items-center mb-2">
                              <span className="font-medium text-sm text-white">{page.name}</span>
                              <span className="text-xs px-2 py-0.5 rounded-full" style={postStatusColors[page.status] || postStatusColors.pending}>{page.status}</span>
                            </div>
                            {editingVariant === page.page_id ? (
                              <div className="mt-2">
                                <TextEditor value={editVariantText} onChange={setEditVariantText} rows={6} />
                                <div className="flex gap-2 mt-2">
                                  <button onClick={() => saveVariant(page.page_id)}
                                    className="px-3 py-1.5 rounded-lg text-xs font-medium" style={btnGreen}>
                                    Salveaza
                                  </button>
                                  <button onClick={() => setEditingVariant(null)}
                                    className="px-3 py-1.5 rounded-lg text-xs" style={btnGray}>
                                    Anuleaza
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div>
                                {page.variant_text ? (
                                  <p className="text-xs whitespace-pre-wrap" style={{color:"rgba(255,255,255,0.5)"}}>{page.variant_text}</p>
                                ) : (
                                  <p className="text-xs italic" style={{color:"rgba(255,255,255,0.2)"}}>Nicio varianta generata</p>
                                )}
                                {!isScheduled && !['posted'].includes(page.status) && (
                                  <div className="flex gap-2 mt-2">
                                    {page.status === 'approved' ? (
                                      <button onClick={() => disapproveVariant(page.page_id)}
                                        className="px-2.5 py-1 rounded-lg text-xs" style={btnRed}>
                                        ↩️ Dezaproba
                                      </button>
                                    ) : (
                                      <>
                                        <button onClick={() => generateVariant(page.page_id)} disabled={generating}
                                          className="px-2.5 py-1 rounded-lg text-xs disabled:opacity-50" style={btnPurple}>
                                          ✨ Genereaza AI
                                        </button>
                                        <button onClick={() => { setEditingVariant(page.page_id); setEditVariantText(page.variant_text || ''); }}
                                          className="px-2.5 py-1 rounded-lg text-xs" style={btnGray}>
                                          ✏️ {page.variant_text ? 'Editeaza' : 'Scrie manual'}
                                        </button>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                            <MediaUpload campaignId={selectedCampaign.id} pageId={page.page_id}
                              showPublish={page.status === 'approved' && !isScheduled}
                              onPublish={() => publishVariantWithMedia(selectedCampaign.id, page.page_id)}
                              disabled={['approved','posted','scheduled'].includes(page.status)} />
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
        )}

        {selectedCampaign && editMode && editCampaign && (
          <div className="col-span-1 md:col-span-2 rounded-2xl p-6" style={{...card, border:"1px solid rgba(99,102,241,0.3)"}}>
            <h3 className="text-lg font-bold mb-4 text-white">Editeaza campania</h3>
            <FormFields data={editCampaign} setData={setEditCampaign} pages={pages} domains={domains} />
            <div className="flex gap-2 mt-4">
              <button onClick={updateCampaign} className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>Salveaza</button>
              <button onClick={() => setEditMode(false)} className="px-4 py-2 rounded-xl text-sm font-medium" style={btnGray}>Anuleaza</button>
            </div>
          </div>
        )}


      </div>
      )}
    </div>
  );
}
